import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { selectWebsiteTheme } from '../../store/slices/website';
import CLFontIcon from '../CLFontIcon';

import {
  Container, Toggle, ClearButton, Dropdown,
} from './styled';

const CLDropdown = ({ label, renderContent }) => {
  const { colors } = useSelector(selectWebsiteTheme);
  const [open, setOpen] = useState(false);

  return (
    <Container>
      <Toggle
        oColor={colors[6].color}
        bColor={colors[3].color}
        bgColor={colors[0].color}
        onClick={() => setOpen((value) => !value)}
      >
        <span>{label}</span>
        <ClearButton
          color={colors[4].color}
        >
          <CLFontIcon icon={open ? 'caret-up' : 'caret'} />
        </ClearButton>
      </Toggle>

      {open && (
        <Dropdown
          bColor={colors[3].color}
          bgColor={colors[0].color}
        >
          {renderContent()}
        </Dropdown>
      )}
    </Container>
  );
};

CLDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  renderContent: PropTypes.func.isRequired,
};

CLDropdown.defaultProps = {

};

export default CLDropdown;
